import { useCallback, useState } from "react";
import { useAuth } from "@clerk/react";
import { fetchReel } from "@/lib/reels";

// Downloads a list of links with limited parallelism; 4K upscales run one at a time.
export function useDownloadQueue(quality) {
  const { getToken, isSignedIn } = useAuth();
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);

  const update = (i, patch) => setItems((prev) => prev.map((it, idx) => (idx === i ? { ...it, ...patch } : it)));

  const run = useCallback(async (entries) => {
    const queue = entries.map((e) => (typeof e === "string" ? { url: e } : e)).map((e) => ({ ...e, state: "queued" }));
    setItems(queue);
    setBusy(true);
    let next = 0;
    const worker = async () => {
      while (next < queue.length) {
        const i = next++;
        update(i, { state: "loading", progress: null });
        try {
          const token = isSignedIn ? await getToken() : null;
          const onProgress = (p) => update(i, { progress: p });
          update(i, { state: "done", ...(await fetchReel(queue[i].url, { quality, token, onProgress })) });
        } catch (e) {
          update(i, { state: "error", error: e.message });
        }
      }
    };
    const n = quality === "4k" ? 1 : 3;
    await Promise.all(Array.from({ length: Math.min(n, queue.length) }, worker));
    setBusy(false);
  }, [quality, getToken, isSignedIn]);

  return { items, busy, run, reset: () => setItems([]) };
}
